import { Journey } from '../../lib/types/models/product/journey'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getJourney(id: number) {
  return restApiClient.url(constructApiUrl(API.products.getJourney.url, { id })).get<Journey>()
}
